import { GA_EVENTS } from '../../../../../common/constants';
import { trackGAEvent, trackGAEventWithUserData } from '../../../utils/gaTracking';
import fetchUserTrackingData from '../repositories/fetchUserTrackingData';

export default async function safeTrackLoginSuccess(xsrfToken: string) {
  try {
    const userTrackingData = await fetchUserTrackingData(xsrfToken);
    trackGAEventWithUserData({
      eventAction: GA_EVENTS.LoginSuccess,
      userData: userTrackingData || undefined,
    });
  } catch {
    trackGAEvent(GA_EVENTS.LoginSuccess);
  }
}
